<template>
    <Header></Header>
    <Left></Left>
    <section class="container" id="printArea">
        <div>
            <div class="area_title">
                <p>내담자 목록</p>
                <div class="area_button noPrint">
                    <!-- <button type="button" @click="CommonUtils.printSection">
                        <img src="img/print.png" />
                        <span>PDF 출력</span>
                    </button> -->
                    <button type="button" @click="downloadFile">
                        <img src="img/excel.png" />
                        <span>Excel 다운</span>
                    </button>
                </div>
            </div>
            <div class="area_body">
                <div class="area_section">
                    <div class="area_tab">
                        <div
                            :class="{ selected: state.dept === 0 }"
                            @click="
                                state.dept = 0;
                                router.push({ name: 'client', query: { dept: state.dept } });
                                fnGetList(1);
                            "
                        >
                            <span>전체</span>
                        </div>
                        <div
                            :class="{ selected: state.dept === 1 }"
                            @click="
                                state.dept = 1;
                                router.push({ name: 'client', query: { dept: state.dept } });
                                fnGetList(1);
                            "
                        >
                            <span>상담팀</span>
                        </div>
                        <div
                            :class="{ selected: state.dept === 3 }"
                            @click="
                                state.dept = 3;
                                router.push({ name: 'client', query: { dept: state.dept } });
                                fnGetList(1);
                            "
                        >
                            <span>현장팀</span>
                        </div>
                        <div
                            :class="{ selected: state.dept === 4 }"
                            @click="
                                state.dept = 4;
                                router.push({ name: 'client', query: { dept: state.dept } });
                                fnGetList(1);
                            "
                        >
                            <span>기타</span>
                        </div>
                    </div>
                    <div class="area_search">
                        <div v-if="state.dept === 1" class="area_search_checkbox">
                            <div>
                                <div class="checkbox_wrap">
                                    <label>
                                        <input
                                            type="checkbox"
                                            :checked="state.isChild === 1"
                                            @click="
                                                state.isChild = state.isChild === 1 ? 0 : 1;
                                                fnGetList(1);
                                            "
                                        />
                                        <em></em>
                                        <span>청소년팀만</span>
                                    </label>
                                </div>
                            </div>
                        </div>
                        <div>
                            <label>작성일</label>
                            <div>
                                <div class="datepicker"><input type="date" id="startDate" v-model="state.startDate" @change="changeStartDate" /></div>
                                <span>~</span>
                                <div class="datepicker"><input type="date" id="endDate" v-model="state.endDate" @change="changeEndDate" /></div>
                                <button
                                    type="button"
                                    @click="
                                        setDateToToday();
                                        fnGetList(1);
                                    "
                                >
                                    오늘날짜
                                </button>
                            </div>
                        </div>
                        <div>
                            <label>검색조건1</label>
                            <div>
                                <div class="select-wrap">
                                    <select name="searchType" v-model="state.searchType1">
                                        <option value="">선택해주세요.</option>
                                        <option v-for="item in searchCondition" :value="item.key">{{ item.name }}</option>
                                    </select>
                                </div>
                                <template v-if="state.searchType1 !== 'state' && state.searchType1 !== 'counselType'">
                                    <input
                                        type="text"
                                        name="searchText"
                                        v-model="state.searchText1"
                                        placeholder="검색어를 입력해주세요."
                                        v-on:keyup.enter="fnGetList(1)"
                                    />
                                </template>
                                <template v-else>
                                    <div class="select-wrap">
                                        <select
                                            name="searchType"
                                            v-model="state.searchText1"
                                            v-if="state.searchType1 === 'state'"
                                            @change="fnGetList(1)"
                                        >
                                            <option value="">선택해주세요.</option>
                                            <option v-for="item in stateList" :value="item.key">{{ item.name }}</option>
                                        </select>

                                        <select name="searchType" v-model="state.searchText1" v-else @change="fnGetList(1)">
                                            <option value="">선택해주세요.</option>
                                            <option v-for="item in CommonOptions.counselTypeList" :value="item.key">{{ item.name }}</option>
                                        </select>
                                    </div>
                                </template>
                            </div>
                        </div>
                        <div>
                            <label>검색조건2</label>
                            <div>
                                <div class="select-wrap">
                                    <select name="searchType" v-model="state.searchType2">
                                        <option value="">선택해주세요.</option>
                                        <option v-for="item in searchCondition" :value="item.key">{{ item.name }}</option>
                                    </select>
                                </div>
                                <template v-if="state.searchType2 !== 'state' && state.searchType2 !== 'counselType'">
                                    <input
                                        type="text"
                                        name="searchText"
                                        v-model="state.searchText2"
                                        placeholder="검색어를 입력해주세요."
                                        v-on:keyup.enter="fnGetList(1)"
                                    />
                                </template>
                                <template v-else>
                                    <div class="select-wrap">
                                        <select
                                            name="searchType"
                                            v-model="state.searchText2"
                                            v-if="state.searchType2 === 'state'"
                                            @change="fnGetList(1)"
                                        >
                                            <option value="">선택해주세요.</option>
                                            <option v-for="item in stateList" :value="item.key">{{ item.name }}</option>
                                        </select>

                                        <select name="searchType" v-model="state.searchText2" v-else @change="fnGetList(1)">
                                            <option value="">선택해주세요.</option>
                                            <option v-for="item in CommonOptions.counselTypeList" :value="item.key">{{ item.name }}</option>
                                        </select>
                                    </div>
                                </template>
                            </div>
                        </div>

                        <div>
                            <label>검색조건3</label>
                            <div>
                                <div class="select-wrap">
                                    <select name="searchType" v-model="state.searchType3">
                                        <option value="">선택해주세요.</option>
                                        <option v-for="item in searchCondition" :value="item.key">{{ item.name }}</option>
                                    </select>
                                </div>
                                <template v-if="state.searchType3 !== 'state' && state.searchType3 !== 'counselType'">
                                    <input
                                        type="text"
                                        name="searchText"
                                        v-model="state.searchText3"
                                        placeholder="검색어를 입력해주세요."
                                        v-on:keyup.enter="fnGetList(1)"
                                    />
                                </template>
                                <template v-else>
                                    <div class="select-wrap">
                                        <select
                                            name="searchType"
                                            v-model="state.searchText3"
                                            v-if="state.searchType3 === 'state'"
                                            @change="fnGetList(1)"
                                        >
                                            <option value="">선택해주세요.</option>
                                            <option v-for="item in stateList" :value="item.key">{{ item.name }}</option>
                                        </select>

                                        <select name="searchType" v-model="state.searchText3" v-else @change="fnGetList(1)">
                                            <option value="">선택해주세요.</option>
                                            <option v-for="item in CommonOptions.counselTypeList" :value="item.key">{{ item.name }}</option>
                                        </select>
                                    </div>
                                </template>
                            </div>
                        </div>

                        <div>
                            <label>검색조건4</label>
                            <div>
                                <div class="select-wrap">
                                    <select name="searchType" v-model="state.searchType4">
                                        <option value="">선택해주세요.</option>
                                        <option v-for="item in searchCondition" :value="item.key">{{ item.name }}</option>
                                    </select>
                                </div>
                                <template v-if="state.searchType4 !== 'state' && state.searchType4 !== 'counselType'">
                                    <input
                                        type="text"
                                        name="searchText"
                                        v-model="state.searchText4"
                                        placeholder="검색어를 입력해주세요."
                                        v-on:keyup.enter="fnGetList(1)"
                                    />
                                </template>
                                <template v-else>
                                    <div class="select-wrap">
                                        <select
                                            name="searchType"
                                            v-model="state.searchText4"
                                            v-if="state.searchType4 === 'state'"
                                            @change="fnGetList(1)"
                                        >
                                            <option value="">선택해주세요.</option>
                                            <option v-for="item in stateList" :value="item.key">{{ item.name }}</option>
                                        </select>

                                        <select name="searchType" v-model="state.searchText4" v-else @change="fnGetList(1)">
                                            <option value="">선택해주세요.</option>
                                            <option v-for="item in CommonOptions.counselTypeList" :value="item.key">{{ item.name }}</option>
                                        </select>
                                    </div>
                                </template>
                            </div>
                        </div>

                        <div class="area_button">
                            <button
                                type="button"
                                @click="
                                    reset();
                                    fnGetList(1);
                                "
                            >
                                초기화
                            </button>
                            <button type="button" @click="fnGetList(1)">검색</button>
                        </div>
                    </div>
                </div>

                <div class="area_section">
                    <div class="area_table">
                        <div class="area_table_head">
                            <div class="select-wrap">
                                <select name="orderType" v-model="state.order" @change="fnGetList(1)">
                                    <option value="0">최근순</option>
                                    <option value="1">과거순</option>
                                </select>
                            </div>

                            <div class="total_length">
                                {{ $t("notice.total") }} : {{ CommonUtils.numberFormat(pageState.length) }} {{ $t("notice.count") }}
                            </div>
                        </div>
                        <div class="area_table_body">
                            <DataGrid
                                :list="pageState.list"
                                :columns="pageState.fields"
                                :totalLength="pageState.length"
                                :perPage="pageState.perPage"
                                :cntPage="pageState.cntPage"
                                :current-page="pageState.currentPage"
                                :isLoading="pageState.isLoading"
                                @onRowClick="fnRowClick"
                                @onPaging="fnGetList"
                                @onNextPage="fnGoPage"
                                @onPrevPage="fnGoPage"
                                @onFirstPage="fnGoPage"
                                @onLastPage="fnGoPage"
                            ></DataGrid>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </section>
    <Spinner :is-full-page="true" v-if="state.isLoading"></Spinner>
    <ModalDefault
        v-if="state.isShowModal"
        :type="state.modalTab"
        :title="state.modalTitle"
        :content="state.modalContent"
        @close="state.isShowModal = false"
    ></ModalDefault>
</template>
<script lang="ts" config>
    import {
        userStore,
        globalStore,
        DataGrid,
        reactive,
        watch,
        apiService,
        onActivated,
        router,
        Header,
        Left,
        ModalDefault,
        types,
        getMessageByCode,
        PageBtn,
        CommonUtils,
        CommonOptions,
        useRoute,
        Spinner,
    } from "@/BaseComponent";

    export default {
        props: {},
        components: { Header, Left, ModalDefault, PageBtn, DataGrid, Spinner },
        setup() {
            const global = globalStore();
            const user = userStore();
            const route = useRoute();

            const dayAgo = new Date();

            const today = new Date();
            dayAgo.setDate(today.getDate() - 90);

            const state = reactive({
                startDate: "" as string,
                endDate: "" as string,
                searchType1: "number" as string,
                searchText1: "" as string,
                searchType2: "name" as string,
                searchText2: "" as string,
                searchType3: "writer" as string,
                searchText3: "" as string,
                searchType4: "counselor" as string,
                searchText4: "" as string,
                dept: 0 as number,
                order: 0 as number,
                isChild: 0 as 0 | 1,

                isShowModal: false as boolean,
                modalTab: -1 as number,
                modalIsResult: false as boolean,
                modalTitle: "alert" as string,
                modalContent: "" as string,

                isLoading: false,
            });

            const searchCondition = [
                { key: "number", name: "연번" },
                { key: "name", name: "이름" },
                // { key: "consultDepartment", name: "상담부서" },
                { key: "writer", name: "초기상담원" },
                { key: "counselor", name: "담당상담원" },
                { key: "state", name: "진행상황" },
                { key: "counselType", name: "상담유형" },
                { key: "phone", name: "연락처" },
            ];

            const stateList = [
                { key: 0, name: "데이터 없음" },
                { key: 1, name: "진행" },
                { key: 2, name: "종결" },
                { key: 3, name: "보류" },
                { key: 4, name: "비해당" },
            ];

            const pageState = reactive({
                perPage: 10,
                cntPage: 5,
                currentPage: 1,
                list: [] as any,
                length: 0 as number,
                isLoading: false,
                fields: [
                    { key: "", label: "No.", class: "text-center" },
                    { key: "idx", label: "IDX", class: "text-center" },
                    {
                        key: "number",
                        label: "연번",
                        clickable: true,
                        class: "text-left",
                    },
                    {
                        key: "isRealMember",
                        label: "실인원 여부",
                        clickable: true,
                        class: "text-center",
                        render: (row: any) => {
                            return `
                            <div class="checkbox_wrap">
                                    <label>
                                        <input type = "checkbox" name = "isRealMember" ${row.isRealMember === 1 ? "checked" : ""}>
                                        <em></em>

                                    </label>
                                </div>
                            `;
                        },
                    },
                    {
                        key: "name",
                        label: "이름",
                        clickable: false,
                        class: "text-center",
                    },
                    {
                        key: "clientDetailVO.phone",
                        label: "전화번호",
                        clickable: false,
                        class: "text-center",
                        render: (row: any) => {
                            if (row.clientDetailVO) return CommonUtils.convertPhoneNum(row.clientDetailVO.phone);
                            return "";
                        },
                    },
                    {
                        key: "clientDetailVO.birth",
                        label: "생년월일",
                        clickable: false,
                        class: "text-center",
                        render: (row: any) => {
                            if (row.clientDetailVO) return CommonUtils.dateFormatYYYYMMDD(row.clientDetailVO.birth, ".");
                            return "";
                        },
                    },
                    {
                        key: "cntCounsel",
                        label: "상담건 수",
                        class: "text-center td_counsel",
                        render: (row: any) => {
                            if (row.cntCounsel > 0) return CommonUtils.numberFormat(row.cntCounsel);
                            return 0;
                        },
                    },
                    {
                        key: "consultDepartment",
                        label: "상담부서",
                        class: "text-center",
                    },
                    {
                        key: "counselor",
                        label: "담당상담원",
                        class: "text-center",
                    },
                    {
                        key: "state",
                        label: "진행상황",
                        class: "text-center",
                        render: (row: any) => {
                            let strResult = "";
                            switch (row.state) {
                                case 0:
                                    strResult = "데이터 없음";
                                    break;
                                case 1:
                                    strResult = "진행";
                                    break;
                                case 2:
                                    strResult = "종결";
                                    break;
                                case 3:
                                    strResult = "보류";
                                    break;
                                case 4:
                                    strResult = "비해당";
                                    break;
                                default:
                                    strResult = "데이터 없음";
                                    break;
                            }

                            if (row.state === 1 && row.stateSub && row.stateSub !== "" && row.stateSub !== "-") {
                                strResult += ` (${row.stateSub})`;
                            }
                            return strResult;
                        },
                    },
                    {
                        key: "counselType",
                        label: "상담유형",
                        class: "text-center",
                        render: (row: any) => {
                            let strResult = "";
                            switch (row.counselType) {
                                case 1:
                                    strResult = "전화상담";
                                    break;
                                case 2:
                                    strResult = "내방상담";
                                    break;
                                case 3:
                                    strResult = "방문상담";
                                    break;
                                case 4:
                                    strResult = "사이버";
                                    break;
                                case 5:
                                    strResult = "아웃리치";
                                    break;
                                case 6:
                                    strResult = "현장상담";
                                    break;
                                default:
                                    strResult = "데이터 없음";
                                    break;
                            }
                            return strResult;
                        },
                    },
                    {
                        key: "state",
                        label: "승인 상태",
                        class: "text-center",
                        render: (row: any) => {
                            let strResult = "";
                            switch (row.isCheck) {
                                case 0:
                                    strResult = "대기";
                                    break;
                                case 1:
                                    strResult = "승인";

                                    // if (row.commentForTeamLeader && row.commentForTeamLeader) {
                                    //     strResult += `(O)`;
                                    // }
                                    break;
                                case 2:
                                    strResult = "보완 요청";
                                    break;
                            }
                            return strResult;
                        },
                    },
                ],
            });

            onActivated(() => {
                const dept = Number(route.query.dept ?? 0);
                state.dept = dept;
                if (Number(route.query.dept) !== dept) {
                    router.replace({ name: "client", query: { dept } });
                }

                if (user.userInfo.auth !== 8) {
                    pageState.fields = pageState.fields.filter((r) => r.key !== "isRealMember");
                }
                // state.startDate = dayAgo.toLocaleDateString("sv-SE");
                // state.endDate = today.toLocaleDateString("sv-SE");
                fnGetList(pageState.currentPage);
            });

            watch(
                () => route.query.dept,
                () => {
                    if (route.name !== "client") return;

                    const dept = Number(route.query.dept ?? 0);
                    if (state.dept !== Number(route.query.dept)) {
                        router.replace({ name: "client", query: { dept } });
                        pageState.currentPage = 1;
                    }

                    if (state.dept !== dept) {
                        state.dept = dept;
                    }

                    if (user.userInfo.auth !== 8) {
                        pageState.fields = pageState.fields.filter((r) => r.key !== "isRealMember");
                    }

                    // // state.startDate = dayAgo.toLocaleDateString("sv-SE");
                    // // state.endDate = today.toLocaleDateString("sv-SE");
                    fnGetList(pageState.currentPage);
                },
            );

            const reset = () => {
                state.startDate = "";
                state.endDate = "";
                state.searchType1 = "";
                state.searchText1 = "";
                state.searchType2 = "";
                state.searchText2 = "";
                state.searchType3 = "";
                state.searchText3 = "";
                state.searchType4 = "";
                state.searchText4 = "";
                state.dept = 0;
                state.order = 0;
            };

            const fnGetList = async (page: number) => {
                pageState.currentPage = page;
                pageState.isLoading = true;
                const param: types.client.ReqClientList = {
                    page: page,
                    size: pageState.perPage,
                    searchType1: state.searchType1,
                    searchText1: state.searchText1,
                    searchType2: state.searchType2,
                    searchText2: state.searchText2,
                    searchType3: state.searchType3,
                    searchText3: state.searchText3,
                    searchType4: state.searchType4,
                    searchText4: state.searchText4,
                    order: state.order,
                    dept: state.dept,
                    isChild: state.isChild,
                    startDate: state.startDate,
                    endDate: state.endDate,
                    searchType: "",
                    searchText: "",
                };
                let res: types.ResPaging = await apiService.client.list(param);

                if (res.returnCode === 0 && res.list) {
                    pageState.list = res.list.data;
                    pageState.length = res.list.recordsTotal;
                } else {
                    console.error(res.description);
                }
                pageState.isLoading = false;
            };

            const fnRowClick = (row: any, col: any) => {
                if (col.key === "isRealMember") {
                    setIsRealMember(row, row.isRealMember);
                } else if (col.key === "number") {
                    if (user.userInfo.auth > 5) {
                        if (
                            row.consultDepartment !== user.userInfo.team &&
                            user.userInfo.auth < 8 &&
                            !(user.userInfo.auth === 5 && row.consultDepartment === "기타")
                        ) {
                            state.modalTab = -1;
                            state.modalTitle = "알림";
                            state.modalContent = "접근 권한이 없습니다.";
                            state.isShowModal = true;
                            return;
                        }
                        router.push({ name: "clientDetail", params: { id: row.idx } });
                    } else {
                        state.modalTab = -1;
                        state.modalTitle = "알림";
                        state.modalContent = "접근 권한이 없습니다.";
                        state.isShowModal = true;
                        return;
                    }
                }
            };

            const fnGoPage = (page: number) => {
                pageState.currentPage = page;
            };

            const setDateToToday = () => {
                state.startDate = dayAgo.toLocaleDateString("sv-SE");
                state.endDate = today.toLocaleDateString("sv-SE");
            };

            const setIsRealMember = async (item: any, isRealMember: number) => {
                const param: types.client.ReqClientForRealMember = {
                    isRealMember: isRealMember === 1 ? 0 : 1,
                };
                const res = await apiService.client.changeRealMember(item.idx, param);

                if (res.returnCode === 0) {
                    fnGetList(pageState.currentPage);
                } else {
                    console.error(res.description);
                }
            };

            const downloadFile = async () => {
                state.isLoading = true;
                try {
                    const param: types.client.ReqClientList = {
                        page: 0,
                        size: 0,
                        searchType1: state.searchType1,
                        searchText1: state.searchText1,
                        searchType2: state.searchType2,
                        searchText2: state.searchText2,
                        searchType3: state.searchType3,
                        searchText3: state.searchText3,
                        searchType4: state.searchType4,
                        searchText4: state.searchText4,
                        order: state.order,
                        dept: state.dept,
                        isChild: state.isChild,
                        startDate: state.startDate,
                        endDate: state.endDate,
                        searchType: "",
                        searchText: "",
                    };
                    let res = await apiService.client.exportExcel(param);
                    if (res && res.data) {
                        const blob = new Blob([res.data], {
                            type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
                        });
                        const disposition = res.headers["content-disposition"];
                        let fileName = "download.xlsx";
                        if (disposition) {
                            const match = disposition.match(/filename="?(.+)"?/);
                            if (match && match[1]) {
                                fileName = decodeURIComponent(match[1]);
                            }
                        }
                        const a = document.createElement("a");
                        const url = window.URL.createObjectURL(blob);
                        a.href = url;
                        a.download = fileName;
                        document.body.appendChild(a);
                        a.click();
                        document.body.removeChild(a);
                        URL.revokeObjectURL(url);
                    } else {
                        state.modalTab = -1;
                        state.modalTitle = "알림";
                        state.modalContent = getMessageByCode(res.returnCode);
                        state.isShowModal = true;
                    }
                } catch (err) {
                    console.error("파일 다운로드 실패:", err);
                    state.modalTab = -1;
                    state.modalTitle = "알림";
                    state.modalContent = "파일 다운로드 실패";
                    state.isShowModal = true;
                }
                state.isLoading = false;
            };

            const changeStartDate = () => {
                if (!CommonUtils.checkDateRange(state.startDate, state.endDate)) {
                    state.endDate = state.startDate;
                }
            };
            const changeEndDate = () => {
                if (state.startDate === "") {
                    state.startDate = state.endDate;
                } else if (!CommonUtils.checkDateRange(state.startDate, state.endDate)) {
                    state.endDate = state.startDate;
                    state.modalTab = -1;
                    state.modalTitle = "알림";
                    state.modalContent = "작성일 범위가 잘못 선택되었습니다.";
                    state.isShowModal = true;
                }
            };

            return {
                state,
                pageState,
                reset,
                fnRowClick,
                fnGoPage,
                fnGetList,
                CommonUtils,
                setDateToToday,
                searchCondition,
                stateList,
                CommonOptions,
                window,
                downloadFile,
                router,
                changeStartDate,
                changeEndDate,
            };
        },
    };
</script>
<style>
    .sch_list label:last-child {
        border-right: white;
    }
</style>
